<template>
    <div>
        <div class="row mb-4">
            <div class="col-md-3">
                <v-select
                    :options="statuses"
                    placeholder="All Job Statuses"
                    v-model="filters.status"
                ></v-select>
            </div>
        </div>
        <table ref="table" class="table table-bordered table-striped table-vcenter dataTable">
            <thead>
                <tr>
                    <th></th>
                    <th>#</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Time Tracking Total</th>
                    <th>Updated At</th>
                    <th></th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>

        <div class="my-3 p-3" :class="{'bg-sidebar-dark': !dark, 'bg-gray-light': dark}" v-if="selectedJobs.length > 0">
            <div class="nav-main-horizontal">
                <button
                    class="btn btn-sm me-2"
                    :class="{'btn-light': !dark, 'btn-dark': dark}"
                    v-on:click="reset"
                >
                    <i class="fa fa-redo"></i> Reset
                </button>
                <p class="m-0 me-2 btn-sm" :class="{'text-white': !dark, 'text-gray-darker' : dark}">
                    {{ selectedJobs.length }} job{{ (selectedJobs.length > 1) ? 's' : '' }} selected
                </p>
                <button
                    class="btn btn-sm btn-success js-emit"
                    data-emit-action="classics-merge-jobs"
                    :data-emit-payload="JSON.stringify(selectedJobs)"
                    v-if="selectedJobs.length > 1"
                >
                    <i class="fa fa-arrows-alt-h"></i> Merge
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { Eventbus } from '@/components/eventbus';
import VSelect from 'vue-select';

export default {
    components: {
        VSelect,
    },

    props: {
        ajaxUrl: String,
        dark: Boolean,
        statuses: Array,
    },

    data () {
        return {
            filters: {
                status: null,
            },
            selectedJobs: [],
        };
    },

    mounted () {
        let table = window.jQuery(this.$refs.table).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[4, 'desc']],
            columns: [
                {
                    data: 'uuid',
                    render: (data, type, row) => {
                        let checked = (this.selectedJobs.indexOf(row.uuid) !== -1);
                        checked = (checked === true) ? 'checked' : '';

                        return `<div class="form-check form-check-inline m-0 p-0 pt-2">
                            <input class="form-check-input m-0" type="checkbox" onchange="selectThisJob(this)" ${checked} value="${row.uuid}" />
                        </div>`;
                    }
                },
                {
                    data: 'number',
                },
                {
                    data: 'description',
                },
                {
                    data: 'status',
                },
                {
                    data: 'time_tracking_total',
                },
                {
                    data: 'updated_at',
                },
                {
                    data: 'actions',
                },
            ]
        });

        document.getElementById('vehicle-jobs-tab').addEventListener('shown.bs.tab', () => {
            this.$refs.table.removeAttribute('style');
            table.columns.adjust();
        });

        Eventbus.on('jobs-table-refresh', () => {
            table.ajax.reload(null, false);
        });

        // watch api to use table without saving it to data
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );

        Eventbus.on('jobs-merged', this.reset);

        window.selectThisJob = (checkbox) => {
            if (checkbox.checked) {
                this.selectedJobs.push(checkbox.value);
            } else {
                this.selectedJobs.splice(this.selectedJobs.indexOf(checkbox.value), 1);
            }
        };
    },

    methods: {
        reset () {
            this.selectedJobs = [];
            Eventbus.emit('jobs-table-refresh');
        }
    }
}
</script>
